<template>
	<div id="companymoney"></div>
</template>

<script>
	import utils from "@/common/utils.js";
	let oldData = [];
	export default {
		props: {
			info: {
				type: Array,
				default () {
					return [];
				}
			},
			type: {
				type: Number,
				default: 0
			}
		},
		watch: {
			info: {
				handler(val) {
					if (val && val.length) {
						oldData = val;
						this.options.xAxis.data = val.map(item => item.ReportDate);
						this.options.title[1].text = `时间：${this.type?'季度':'年月'}`;
						let arr = [];
						val[0].Items.forEach((item, index) => {
							arr.push({
								name: item.LEVEL3,
								type: 'line',
								smooth: true,
								data: val.map(item1 => this.fixedVal(item1.Items[index].Money, 0))
							})
						})
						this.options.series = arr;
						//this.options.dataZoom[0].start = 12 / val.length > 1 ? 0 : (1 - (12 / val.length)) * 100;
						setTimeout(() => {
							this.myChart.clear();
							this.myChart.setOption(this.options);
						}, 200)
					} else {
						this.options.series = [];
						this.myChart.setOption(this.options);
						this.myChart.clear();
					}
				},
				deep: true,
				immediate: true
			}
		},
		data() {
			return {
				myChart: null,
				options: {
					title: [{
						text: '金额：万元',
						left: '4%',
						top: '2%',
						textStyle: {
							color: '#1D2129',
							fontSize: 12,
							fontWeight: 'normal'
						}
					}, {
						text: '时间：年月',
						right: '4%',
						bottom: '18%',
						textStyle: {
							color: '#1D2129',
							fontSize: 12,
							fontWeight: 'normal'
						}
					}],
					tooltip: {
						trigger: 'axis',
						confine: true,
						hideDelay: 3000,
						//order: 'valueDesc',
						//valueFormatter: (value) => value + '万元'
						formatter(params) {
							console.log(params);
							let itemStr = ``;
							params.forEach((item, index) => {
								let fdx = oldData.findIndex(it => it.ReportDate == item.name);
								let fdv = oldData[fdx].Items.findIndex(it => it.LEVEL3 == item.seriesName);
								let it = oldData[fdx].Items[fdv].MoneyRatio;
								itemStr = itemStr +
									`<div style="display:flex;align-items: center;justify-content: space-between;">${item.marker}
									<div style="font-size:14px;font-weight:400;margin:0px 20px 0px 8px;flex:1;">${item.seriesName}</div>
									<div style="font-size:14px;font-weight:500;">
										${item.data}/ ${it?it:'-'}%
									</div>
								</div>`
							})
							//万 
							let viewStr = `<div><div>${params[0].name}</div>${itemStr}</div>`;
							return viewStr;
						}
					},
					legend: {
						bottom: '0%',
						selected: {
							'汇总': false
						}
					},
					grid: {
						left: '8%',
						right: '8%',
						bottom: '30%'
					},
					toolbox: {
						show: true,
						top: 8,
						right: 140,
						feature: {
							saveAsImage: {
								icon: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAA2ZJREFUWEfFl09oE0EUh783m4oHBRGFHnqImMTqSUFBUVAPgj0IHhS8iIoetKS1gqIHxYBeRMXWhFKxoAfBgwcLIgge9KAgWLAH0ZpY7EGxoIJgD7HZ3ZHdTbabv91ognNakpn3++bNe2/eCP95SJV+9PBiFi1dg82yptm09YWp4Y/NrCsHSCQvAudAFjdjJDDXRBubyA1OuL+t612CabxBk6fwaxPTd/OVducBEskUiAPwL2MWy9rge6H7eBS745NrUBVWMTkyXRvAJVXf3J1rHiP6NMqsol2QTKnvvBue9eeFBliT3IiW195CvZZsZnJBsTATQgPEkjtQ8qyRq8Lozc9JRSBl8l8A4snLiJzF5gyRwlhZDJgde1HcQOsT5DIjDrAXhK30QKJ/FPRR7zQZRBio+obrZNOn2wPgpd4TYGudY3tJxNpdCtbWe2A+/2tBlIm3xwOlbVd7whM3VRe2zPIx/bm9ACVPFIwRRJtE7CS/6cQw3gM/yaZXth+gMgiCwZ5Nu8ffnhioVzT+GsA5z4JxFmEzWp7TYQ6VldywVeqvAKK9nSwyHgKbAzrjzFl7mB6eqdZORUj8uAH6mPefGiS7/IJbGZsGiPV1oXgKdBeFnNTaXfz+jCU9TN18W1aC4z/uI+yrABtHFfZjRqJ+yV8wBhLJbnDvh07ARPQRPmTukeg/APoO4PQMs1iyn6mbTyAVISgu3MLWeUROFivhT5SMorVbAWkIYKsucN2+whVBHySbGfN3lTi5DewHPhwygNY7/J1rPUQu45XgRHIviANc3mHVBXAuCpGrwBJPXPWQHXpRddare2MYxqPA8XhTguKlRd0DUWzLAd7o26kLMK80A3pnw94gOrCMDmsMYbsfFxFrbe0McYLz+wiId1EtADCJZe0J12C6hkdBDhVdMMGc3VMzQ0JlATLBnFnbQKN8j/edR7jkewK9q8p7oQAsKx5u5zVoghmiuUwufaFsViiAOt1r2GKH118ewuZK6cbz19YFiPeuR4w3XhRbG8gNe319q0esbx8KJxsqgtB7DX0t5uorHPdpJwVbOESvQOQaEAVekU1vcawHHib9x0DfbqFkPVMmqJ2l2lLxNOs/gNaXEGJtAhkHdSpY2Kofp46yc/3atlOGWzfy+ZnGb8PWSTVl6Q8eGbAwgbTYagAAAABJRU5ErkJggg==',
								name: 'L3公司销量趋势图',
								show: true
							}
						}
					},
					dataZoom: [{
						type: 'slider',
						start: 65,
						end: 100,
						moveHandleSize: 10,
						fillerColor: 'transparent',
						brushSelect: false,
						bottom: '20%',
					}],
					xAxis: {
						type: 'category',
						boundaryGap: false,
						axisTick: {
							show: false
						},
						axisLabel: {
							rotate: 45,
							fontSize: 12,
							color: '#1D2129'
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#E5E6EB',
								type: [5, 10]
							}
						},
						splitLine: {
							show: false
						},
						splitArea: {
							show: false
						},
						data: [],
					},
					yAxis: {
						type: 'value',
						axisLine: {
							show: true,
							lineStyle: {
								color: '#E5E6EB',
								type: [5, 10]
							}
						},
						axisLabel: {
							//rotate: 45,
							fontSize: 12,
							color: '#1D2129'
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: '#E5E6EB',
								type: [5, 10]
							}
						},
						splitArea: {
							show: false
						}
					},
					series: []
				}
			}
		},
		mounted() {
			this.init();
		},
		methods: {
			init() {
				let _this = this;
				this.myChart = this.$MyEcharts.init(document.getElementById('companymoney'));
				this.myChart.clear();
				this.myChart.setOption(this.options);
				window.addEventListener("resize", function() {
					_this.myChart.resize();
				});
			},
			fixedVal(val, num = 1) {
				return (val / 10000).toFixed(num);
			}
		}
	}
</script>

<style lang="less">
	#companymoney {
		height: 750px;
		//margin-top: 16px;
		padding: 16px;
	}
</style>